import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@material-ui/core";

import { getOwnerDashboard } from "../api/MeAPI";
import Progress from "../components/Progress";
import UsersDashboard from "./UsersDashboard";
import CollectionDashboard from "./CollectionDashboard";
import DebtorsDashboard from "./DebtorsDashboard";
import { OwnerDashboardResponse } from "../model/Dashboard";

export default function OwnerDashboard() {
    const [status, setStatus] = useState<string>("loading");
    const [data, setData] = useState<OwnerDashboardResponse>();
    const [activeCustomers, setActiveCustomers] = useState<number>();

    useEffect(() => {
        setStatus("loading");
        getOwnerDashboard().then((response) => {
            setData(response);
            const totalCustomers = response.active_customers + response.inactive_customers;
            if (totalCustomers > 0) {
                setActiveCustomers((response.active_customers * 100) / totalCustomers);
            } else {
                setActiveCustomers(0)
            }

            setStatus("loaded");
        }).catch((error) => {
            setStatus(error.message);
        });
    }, []);

    if (status === "loading") {
        return (<Progress />);
    } else if (status !== "loaded" || data === undefined) {
        return (
            <Typography variant="body1" component="h5" color="error" align="center">
                {status}
            </Typography>
        );
    }

    return (
        <Grid container justify="space-evenly" spacing={3}>
            <Grid item xs={12} lg={data.debtors.length > 1 ? 12 : 8}>
                <CollectionDashboard collection={data.collection} collection_performance={data.collection_performance} dollar={data.dollar} euro={data.euro} activeCustomers={activeCustomers} />
            </Grid>
            {data.debtors.map(debtor => (
                <Grid item key={debtor.currency} xs={12} lg={4}>
                    <DebtorsDashboard debtor={debtor} />
                </Grid>
            ))}
            {data.users_summary && (
                <Grid item xs={12}>
                    <UsersDashboard summary={data.users_summary} />
                </Grid>
            )}
        </Grid>
    );
}
